import { Feature } from 'ol'
import { extend, Extent } from 'ol/extent'
import { Geometry } from 'ol/geom'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { StyleLike } from 'ol/style/Style'
import { useEffect, useMemo } from 'react'

import { useMap } from '../../useMap'
import { emptyStyle } from '../../utils/emptyStyle'
import { geoJsonFeaturesToFeatures } from '../../utils/geojsonHelpers'
import { useLayer } from '../useLayer'
import { VectorLayerProps } from './types'

interface UseVectorLayer {
  layer: VectorLayer<VectorSource>
  style?: StyleLike
  centerFeatures: () => void
  centerFeatureById: (id: string | number) => void
}

export function useVectorLayer(props: VectorLayerProps): UseVectorLayer {
  const { features, zIndex, name, declutter = false } = props

  const style = props.style || emptyStyle

  const { fitExtent } = useMap()

  const layer = useMemo(
    () =>
      new VectorLayer({
        declutter,
        source: new VectorSource(),
        style,
        zIndex,
        className: name,
      }),
    [],
  )

  useLayer({ layer, style })

  useEffect(() => {
    if (!features) {
      return
    }
    layer.setSource(
      new VectorSource({
        features: geoJsonFeaturesToFeatures(features),
      }),
    )
  }, [features])

  const centerFeatures = (): void => {
    let ext: Extent | null = null
    const src = layer.getSource()
    if (src instanceof VectorSource) {
      const features = src.getFeatures() as Feature<Geometry>[]
      features.forEach((feature) => {
        const geom = feature.getGeometry()
        if (geom) {
          const extent = geom.getExtent()
          if (ext) {
            extend(ext, extent)
          } else {
            ext = extent
          }
        }
      })
    }
    fitExtent(ext)
  }

  const centerFeatureById = (id: string | number): void => {
    const src = layer.getSource()
    if (src instanceof VectorSource) {
      // const features = src.getFeatures() as Feature<Geometry>[]
      const ext = (
        src.getFeatureById(id)?.getGeometry() as Geometry
      )?.getExtent()
      fitExtent(ext)
    }
  }

  // TODO: center on load

  // useEffect(() => {
  //   console.log('register change')
  //   layer.on('change', () => {
  //     // center all features on this layer
  //     const extent = layer.getSource()?.getExtent()
  //     console.log('extyent', extent)
  //     if (extent) {
  //       console.log('extent', extent)
  //       map.getView().fit(extent)
  //     }
  //   })
  // }, [layer])

  return {
    layer,
    style,
    centerFeatures,
    centerFeatureById,
  }
}
